import { createContext, useContext } from 'react';

export interface AuthContextValue {
  token?: string | null;
  isSignedIn?: boolean | null;
  signIn(props: { token: string }): void;
  signOut(): void;
}

export const AuthContext = createContext<AuthContextValue>({
  signIn() {
    throw new Error('not implemented');
  },
  signOut() {
    throw new Error('not implemented');
  }
});

export const useAuthContext = () => useContext(AuthContext);
